import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import Home from './pages/Home'
import About from './pages/About'
import Products from './pages/Products'

import Updates from './pages/Updates'
import More from './pages/More'
import Login from './pages/Login'
import Register from './pages/Register'
import Profile from './pages/Dashboard'
import Tags from './pages/Tags'
import Contact from './pages/Contact'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import Refund from './pages/Refund'


import Franchise from './pages/Franchise'
import FranchiseDashboard from './pages/FranchiseDashboard'
import FranchiseMenu from './pages/FranchiseMenu'
import FranchiseTables from './pages/FranchiseTables'
import FranchiseTags from './pages/FranchiseTags'
import Menu from './pages/Menu'
import CustomerMenu from './pages/CustomerMenu'
import Orders from './pages/Orders'
import PaymentResult from './pages/PaymentResult'
import Recharge from './pages/Recharge'
import AdminDashboard from './pages/admin/AdminDashboard'
import AdminUsers from './pages/admin/AdminUsers'
import AdminFranchises from './pages/admin/AdminFranchises'
import AdminTransactions from './pages/admin/AdminTransactions'
import AdminLayout from './pages/admin/AdminLayout'
import QRScan from './pages/QRScan'
import QRScanner from './pages/QRScanner'
import QRCodeDetails from './pages/QRCodeDetails'
import QRCodes from './pages/QRCodes'
import AdminTagScanner from './pages/admin/AdminTagScanner'
import TagsFranchiseDashboard from './pages/TagsFranchiseDashboard'
import { useAuth } from './context/AuthContext'

function AppRoutes() {
  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    )
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/products" element={<Products />} />

      <Route path="/updates" element={<Updates />} />
      <Route path="/more" element={<More />} />
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />}
      />
      <Route
        path="/register"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Register />}
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route path="/dashboard" element={<Navigate to="/profile" replace />} />
      <Route path="/tags" element={<Tags />} />
      <Route path="/franchise" element={<Franchise />} />

      {/* Franchise Admin Routes - In real app, wrap in ProtectedRoute with authorized Role check */}
      <Route path="/franchise/dashboard" element={<FranchiseDashboard />} />
      <Route path="/franchise/menu" element={<FranchiseMenu />} />
      <Route path="/franchise/tables" element={<FranchiseTables />} />
      <Route path="/franchise/tags" element={<FranchiseTags />} />
      <Route path="/franchise/tags-dashboard" element={<TagsFranchiseDashboard />} />

      <Route path="/menu" element={<Menu />} />
      <Route
        path="/orders"
        element={
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        }
      />
      <Route
        path="/payment/result"
        element={
          <ProtectedRoute>
            <PaymentResult />
          </ProtectedRoute>
        }
      />
      <Route path="/recharge" element={<Recharge />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/refund" element={<Refund />} />
    </Routes>
  )
}

import { Toaster } from 'react-hot-toast'

function App() {
  return (
    <>
      <Toaster position="top-center" />
      <Routes>
        {/* Public QR routes - no layout */}
        <Route path="/qr/:uuid" element={<QRScan />} />
        <Route path="/scan" element={<QRScanner />} />
        <Route path="/menu/table/:qrCode" element={<CustomerMenu />} />

        {/* Admin routes with its own layout */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="franchises" element={<AdminFranchises />} />
          <Route path="transactions" element={<AdminTransactions />} />
          <Route path="orders" element={<Orders embeddedAdmin={true} />} />
          <Route path="qrcodes" element={<QRCodes />} />
          <Route path="tag-scan" element={<AdminTagScanner />} />
          <Route path="qrcodes/:id" element={<QRCodeDetails />} />
          <Route path="settings" element={<div>Settings Component</div>} />
        </Route>

        {/* All other routes with layout */}
        <Route path="*" element={
          <Layout>
            <AppRoutes />
          </Layout>
        } />
      </Routes>
    </>
  )
}

export default App


